import { PASUR_TARGETS, type PasurTarget } from "@bing/shared";
import { faDigits } from "../i18n/digits";
import { fa } from "../i18n/fa";

/**
 * پاسور's MATCH TARGETS as a picker offers them — «۶۲ امتیاز» / «۱۰۰ امتیاز» / «۱۰۴ امتیاز», the shared
 * list the server's schema and the solo room accept, nothing else: the solo start screen's, drawn by
 * `SegmentedChoice` as the private host's «تنظیمات میز» draws the bare numbers below (شلم's `shelem-targets.ts`).
 * A platform helper the host's screen imports, which is why its name is not the game's, as `room-sizes.ts`
 * (`pasur-copy.test.ts` holds every پاسور-named module, and every screen importing one, to the game).
 */
export const PASUR_TARGET_CHOICES: readonly (readonly [PasurTarget, string])[] = PASUR_TARGETS.map(
  (n) => [n, fa.pasur.targetOption(faDigits(n))] as const,
);

/** The same list by its bare numbers, as the turn timer's row beside it says its seconds: on «تنظیمات میز»
 *  the picker shares a row with the size, under a heading that already says «امتیاز». */
export const PASUR_TARGET_NUMBER_CHOICES: readonly (readonly [PasurTarget, string])[] =
  PASUR_TARGETS.map((n) => [n, faDigits(n)] as const);
